<template>
  
    
  <b-modal
    lazy
    centered
    size="md"
    :visible="visible"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">
            {{ $t("globals.new") }} {{ $t("globals.fieldtracker_task_name") }}:
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-select
            class="mt-3"
            v-model="selectedDeviceType"
            :options="[
              { value: null, text: $t('globals.select_device_type'), disabled: true },
              ...Object.keys(device_types).map(key => ({
                value: device_types[key],
                text: key
              }))
            ]"
            @change="fetchBillingItems(inverseTypes(selectedDeviceType))"
          >
          </b-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-select
            class="mt-3"
            v-model="selectedTask"
            :options="[
              { value: null, text: $t('globals.select_task'), disabled: true },
              ...Object.keys(tasks).map(key => ({
                value: tasks[key],
                text: key
              }))
            ]"
          >
          </b-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-select
            class="mt-3"
            v-model="selectedApiIdentifier"
            :options="[
              { value: null, text: $t('globals.select_ft_task'), disabled: true },
              ...Object.keys(ft_task).map(key => ({
                value: ft_task[key].api_identifier,
                text: `${ft_task[key].name} (${ft_task[key].api_identifier})`
              }))
            ]"
          >
          </b-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          
          <b-select
            class="mt-3"
            v-model="selectedLicensePlateApiIdentifier"
            :options="[
              { value: null, text: $t('globals.select_license_plate_identifier'), disabled: true },
              ...Object.keys(customFields).map(key => ({
                value: customFields[key].api_identifier,
                text: `${customFields[key].name} (${customFields[key].api_identifier})`
              }))
            ]"
          >
          </b-select>
        </b-col>
      </b-row>
       <b-row>
        <b-col>
          <b-select
            class="mt-3"
            v-model="selectedImeiApiIdentifier"
            :options="[
              { value: null, text: $t('globals.select_imei_identifier'), disabled: true },
              ...Object.keys(customFields).map(key => ({
                value: customFields[key].api_identifier,
                text: `${customFields[key].name} (${customFields[key].api_identifier})`
              }))
            ]"
          >
          </b-select>
        </b-col>
      </b-row>
      <hr />
      <small class="text-muted">
        {{ $t("globals.specific_item_included") }} ({{ $t("globals.optional") }}):
      </small>
      <br />
      <b-row>
        <b-col>
          <b-select
            class="mt-3"
            v-model="selectedBillingItem"
            :options="[
              { value: null, text: $t('globals.order_include_item'), disabled: true },
              ...items.map(item => ({
                value: item.id,
                text: item.item_name
              }))
            ]"
          >
          </b-select>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
           
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="$emit('close')"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
      
    </b-container>
  </b-modal>
  
</template>
<script>
  import { mapActions } from "vuex";
  
  export default {
    
    name: "NewTaskModal",
    props: {
      device_types: {
        type: Object,
        default: () => { return {}; },
      },
      tasks: {
        type: Object,
        default: () => { return {}; },
      },
      visible: {
        type: Boolean,
        default: false,
      },
      ft_task: {
        type: Array,
        default: () => { return []; },
      },
      
    },
    data() {
      return {
        show: false,
        selectedDeviceType: null,
        selectedTask: null,
        selectedApiIdentifier: null,
        selectedLicensePlateApiIdentifier: null,
        selectedImeiApiIdentifier: null,
        selectedBillingItem: null,        
        items: [],
      };
    },
    methods: {
      ...mapActions("axios_mod", ["simpleMutation","simpleFetch"]),
      ...mapActions("fieldtracker", ["fetchTaskTypes",]),
      save() {
        const data = {
          query: `
            mutation FieldtrackerTaskCreate($device_type: Int!, $task: Int!, $api_identifier: String!, $license_plate: String, $imei: String, $billing_item_id: Int!) {
              res: FieldtrackerTaskCreate(device_type: $device_type, task: $task, api_identifier: $api_identifier, license_plate: $license_plate, imei: $imei, billing_item_id: $billing_item_id) {
                id
                api_identifier
                device_type
                task
                license_plate
                imei
              }
            }
          `,
          variables: {
            device_type: this.selectedDeviceType,
            task: this.selectedTask,
            api_identifier: this.selectedApiIdentifier,
            license_plate: this.selectedLicensePlateApiIdentifier,
            imei: this.selectedImeiApiIdentifier,
            billing_item_id: this.selectedBillingItem == null ? null : Number(this.selectedBillingItem),
          },
        };
        console.log("Saving with data:", data);
        this.simpleMutation({ data, this_ref: this }).then(() => {
          this.selectedDeviceType = null;
          this.selectedTask = null;
          this.selectedApiIdentifier = null;
          this.selectedLicensePlateApiIdentifier = null;
          this.selectedImeiApiIdentifier = null;
          this.selectedBillingItem = null;
          this.$emit("close");
        });
      },

      fetchBillingItems(type) {
        this.selectedBillingItem = null; // Reset selected billing item when device type changes
        const typeMapping = {
          blackbox: ['blackbox', 'velpro'],
          dongle: ['dongle', 'vel10']
        };

        if (typeof type === 'string') {
          type = typeMapping[type] || [type];
        }
        
        
        const data = {
          query: `
            query($kpiTypes: [String!]!) {
              itemsByKpiTypePattern(kpi_types: $kpiTypes) {
                id
                item_name
              }
            }
          `,
          variables: {
            kpiTypes: type
          }
        };

        this.simpleFetch({ data, this_ref: this }).then(res => {
          if (res) {
            this.items = res.itemsByKpiTypePattern;
          }
        });
      },

      inverseTypes(value) {
        return Object.keys(this.device_types).find(
        key => this.device_types[key] === value
      );
    }
     
    },
    computed: {
      customFields() {
        if (!this.selectedApiIdentifier) return [];
        return this.ft_task
          .filter(task => task.api_identifier === this.selectedApiIdentifier)
          .flatMap(task => task.custom_task_fields);
      },
    },
    mounted() {
      this.fetchTaskTypes({ this_ref: this });

    },
  };
</script>